<template>
  <div class="home-menu-wrap">
    <div class="logo-wrap">
      <!-- <div class="logo">{{ appConfig.commonProjectName }}</div> -->
      <img class="logo" src="~@/assets/logo.png">
    </div>
    <a-menu
      class="home-menu"
      mode="inline"
    >
      <template v-for="(item) in myMenuList"
        :key="item.key">
        <a-sub-menu v-if="item.children" :key="item.key">
          <template #title>
            <span>{{ item.name }}</span>
          </template>
          <a-menu-item v-for="child in item.children"
            :key="child.key"
            @click="handleMenuClick(child)">{{ child.name }}</a-menu-item>
        </a-sub-menu>
        <a-menu-item v-else @click="handleMenuClick(item)">
          {{ item.name }}
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>
<script>
import config from '@/config'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      menuList: config.menuList,
      permissionDic: config.permissionDic
    }
  },
  computed: {
    ...mapState(['appConfig', 'currentRole']),
    myMenuList () {
      if (!this.currentRole.roleId) {
        return []
      }
      const permList = config.permissionDic[this.currentRole.roleId]
      return config.menuList.map(m => {
        if (m.route) {
          return m
        } else if (m.children) {
          return {
            ...m,
            children: m.children.filter(c => permList.indexOf(c.route) !== -1)
          }
        }
      }).filter(m => {
        return (m.children && m.children.length) || permList.indexOf(m.route) !== -1
      })
    },
    breadcrumb () {
      return this.$route.meta.breadcrumb || []
    }
  },
  methods: {
    handleMenuClick (item) {
      if (item.route === this.$route.name) return
      this.$router.push({ name: item.route })
    }
  }
}
</script>
<style lang="less">
.home-menu-wrap {
  @topHeight: 60px;
  width: 160px; height: 100%;
  background: #01274b;
  color: #fefefe;
  .logo-wrap {
    padding: 15px 0; box-sizing: border-box;
    height: @topHeight;
    text-align: center;
    background: @theme;
    display: flex; align-items: center;
    .logo {
      margin: auto 10px;
      width: 140px; height: auto;
      // height: 100%; line-height: calc(@topHeight - 30px);
      // border-right: 1px solid #fff;
      // font-size: 28px;
    }
  }
  .home-menu {
    margin: 0;
    width: 160px; height: calc(100% - @topHeight);
  }
}
</style>
